// Content extracted from the Figma file "Site Rock Fox"
// (Agbyz3GVGu6p7DCjPf6zzd, page 16:2). The nav columns, service names and
// client list below are transcribed from the expanded menu frame (30:262).
//
// The `figmaNode` on each entry points back at the frame it was built from, so
// a future change in the design can be traced to the code that renders it.

// `menuLabel` is how the expanded menu writes it (30:262); `shortLabel` is the
// service row on the home (16:165). They genuinely differ — the menu says
// "DESIGN ON DEMAND" where the home says just "DESIGN" — so both are kept.
export const SERVICES = [
    {
        slug: "brand-care",
        name: "Brand Care",
        menuLabel: "BRAND CARE",
        shortLabel: "BRAND CARE",
        tagline: "“Somos os guardiões da sua marca.”",
        body: [
            "O Brand Care é nosso serviço mais completo.",
            "Assumimos a gestão criativa da comunicação da sua empresa para garantir consistência, estratégia e personalidade em cada ponto de contato.",
            "Cada publicação, campanha, peça ou decisão criativa passa pelo mesmo direcionamento estratégico, preservando a identidade e fortalecendo a percepção da marca ao longo do tempo.",
        ],
        idealForTitle: "Ideal para empresas que desejam:",
        idealFor: [
            "Comunicação consistente",
            "Direcionamento estratégico.",
            "Identidade visual padronizada.",
            "Acompanhamento criativo contínuo.",
            "Um parceiro que pensa a marca, não apenas executa peças.",
        ],
        figmaNode: "25:11",
    },
    {
        slug: "identidade-visual",
        name: "Identidade Visual",
        menuLabel: "IDENTIDADE VISUAL",
        shortLabel: "IDENTIDADE VISUAL",
        tagline: "“A primeira impressão também pode ser inesquecível.”",
        body: [
            "Uma identidade visual vai muito além de um logotipo. Ela traduz a essência da marca em um sistema visual capaz de comunicar seus valores, posicionamento e personalidade.",
            "Desenvolvemos identidades estratégicas, pensadas para funcionar em todos os pontos de contato da empresa, criando reconhecimento e fortalecendo sua presença no mercado.",
        ],
        idealForTitle: "O que compõe a entrega",
        idealFor: [
            "Direcionamento visual da marca.",
            "Construção de um sistema visual proprietário.",
            "Desenvolvimento do logotipo e suas assinaturas institucionais.",
            "Definição da linguagem cromática, tipográfica e gráfica.",
            "Regras de aplicação e padronização da identidade.",
            "Manual técnico para implementação da marca.",
            "Kit completo de arquivos profissionais para uso interno e externo.",
        ],
        figmaNode: "30:100",
    },
    {
        slug: "packpost",
        name: "Pack Post",
        menuLabel: "PACKPOST",
        shortLabel: "PACKPOST",
        tagline: "“Design profissional para quem já sabe o que quer comunicar.”",
        body: [
            "O Pack Post é um pacote de artes para redes sociais, ideal para empresas que já possuem planejamento e conteúdo, mas precisam de um design profissional para transformar suas ideias em publicações de alto nível.",
            "Cuidamos exclusivamente da criação visual, mantendo qualidade, organização e consistência estética.",
            "Disponível em pacotes personalizados de publicações, conforme a necessidade da sua empresa.",
        ],
        idealForTitle: "Ideal para quem precisa de:",
        idealFor: [
            "Artes para Instagram e redes sociais.",
            "Agilidade na produção.",
            "Excelente custo-benefício.",
            "Design alinhado à identidade da marca.",
        ],
        figmaNode: "30:152",
    },
    {
        slug: "design-on-demand",
        name: "Design",
        menuLabel: "DESIGN ON DEMAND",
        shortLabel: "DESIGN",
        tagline: "“Soluções criativas para qualquer ponto de contato da sua marca.”",
        body: [
            "Nem todo projeto se resume às redes sociais.",
            "Criamos materiais gráficos e institucionais para fortalecer a comunicação da sua empresa nos ambientes físico e digital.",
            "Desenvolvemos peças sob demanda, sempre respeitando a identidade da marca e os objetivos de cada projeto.",
        ],
        idealForTitle: "Entre os materiais que desenvolvemos:",
        idealFor: [
            "Folders e flyers.",
            "Embalagens e rótulos.",
            "Papelaria institucional.",
            "Materiais para eventos.",
            "Banners e outdoors.",
            "Brindes personalizados.",
            "Uniformes e vestuário.",
            "Sinalização e comunicação visual.",
            "Materiais promocionais em geral.",
        ],
        figmaNode: "30:206",
    },
];

// Order follows the menu column, which is the designer's chosen order.
// `service` labels come from the "Bests Cases" grid on the André page (40:10);
// clients without one are not labelled there yet.
// `service` is the service a client was hired for. `bestCase` marks the four that
// the founder page's rail shows (40:10) — that rail is a curated selection, not
// "everyone with a service", so the two are separate flags on purpose.
// `deliverables` feeds the case page's sidebar (30:315).
// `testimonial` is the client's own words, rendered on that client's case page.
// It arrived by WhatsApp from André on 17/08/2026, for three of the clients; the
// rest have none yet and their case pages simply omit the block. The text is
// transcribed, not edited — no word is changed and no sentence is rewritten. The
// one intervention is where Renato's stops, noted at that entry.
export const CLIENTS = [
    {
        slug: "andreetta-contabilidade",
        name: "Andreetta Contabilidade",
        menuLabel: "ANDREETTA CONTABILIDADE",
        service: "Brand Care",
        bestCase: true,
        logo: "/images/clientes/andreetta-contabilidade/logo.png",
        cover: "/images/clientes/andreetta-contabilidade/cover-1.jpg",
        photos: [
            "/images/clientes/andreetta-contabilidade/cover-1.jpg",
            "/images/clientes/andreetta-contabilidade/cover-2.jpg",
            "/images/clientes/andreetta-contabilidade/cover-3.jpg",
        ],
        summary: [
            "Com mais de 60 anos de história, a Andreetta Contabilidade é um escritório contábil localizado em Americana, no interior de São Paulo.",
            "Ao longo de sua trajetória, construiu uma atuação baseada no acompanhamento de empresas e na prestação de serviços na área contábil. Com uma história consolidada na região, o escritório faz parte de uma tradição familiar que atravessa diferentes momentos do mercado e das empresas que atende.",
            "Hoje, segue atuando no segmento de contabilidade, oferecendo suporte para a gestão e organização das demandas contábeis de seus clientes.",
        ],
        posts: [
            "/images/clientes/andreetta-contabilidade/posts/post-1.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-2.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-3.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-4.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-5.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-6.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-7.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-8.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-9.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-10.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-11.jpg",
            "/images/clientes/andreetta-contabilidade/posts/post-12.jpg",
        ],
        testimonial: {
            person: "Renato Andreetta",
            quote: [
                "Nosso escritório cresceu em visibilidade após o início da parceria. E continuamos crescendo.",
                "A parceria é sólida e tem, desde seu início, rendido ótimos frutos.",
            ],
        },
    },
    {
        slug: "rio-grande-pescados",
        name: "Rio Grande Pescados",
        menuLabel: "RIO GRANDE PESCADOS",
        logo: "/images/clientes/rio-grande-pescados/logo.png",
        cover: "/images/clientes/rio-grande-pescados/cover-1.jpg",
        photos: [
            "/images/clientes/rio-grande-pescados/cover-1.jpg",
            "/images/clientes/rio-grande-pescados/cover-2.jpg",
            "/images/clientes/rio-grande-pescados/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/rio-grande-pescados/posts/fundo-principal.jpg",
        summary: [
            "A Rio Grande Pescados atua no mercado de produtos marítimos, com um portfólio voltado principalmente para peixes e outros produtos destinados ao preparo e comercialização de alimentos.",
            "Seus produtos são comercializados para estabelecimentos como restaurantes, bares, lanchonetes e cantinas, que utilizam os pescados em seus próprios preparos e os oferecem ao consumidor final.",
            "A empresa atua principalmente na Região Metropolitana de Campinas, atendendo negócios que buscam produtos para compor seu cardápio. Seu modelo de atuação está direcionado ao fornecimento de produtos para o mercado de alimentação.",
        ],
        posts: [
            "/images/clientes/rio-grande-pescados/posts/post-1.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-2.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-3.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-4.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-5.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-6.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-7.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-8.jpg",
            "/images/clientes/rio-grande-pescados/posts/post-9.jpg",
        ],
    },
    {
        slug: "debora-miranda",
        name: "Débora Miranda",
        menuLabel: "DÉBORA MIRANDA",
        service: "Identidade Visual",
        bestCase: true,
        logo: "/images/clientes/debora-miranda/logo.png",
        cover: "/images/clientes/debora-miranda/cover-1.jpg",
        photos: [
            "/images/clientes/debora-miranda/cover-1.jpg",
            "/images/clientes/debora-miranda/cover-2.jpg",
            "/images/clientes/debora-miranda/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/debora-miranda/posts/fundo-principal.jpg",
        summary: [
            "Débora é profissional de Pilates e atua com a prática voltada ao movimento, ao bem-estar e à qualidade de vida.",
            "Seu trabalho inclui o Pilates Solo, uma modalidade que utiliza o próprio corpo e diferentes exercícios para desenvolver força, flexibilidade, equilíbrio, mobilidade e consciência corporal.",
            "A proposta é tornar o Pilates uma prática acessível para diferentes pessoas e momentos da vida, respeitando os limites e as necessidades de cada aluno.",
            "Atualmente, Débora também trabalha na construção de uma presença digital mais consistente, apresentando a prática de forma clara, próxima e convidativa.",
        ],
        posts: [
            "/images/clientes/debora-miranda/posts/post-1.jpg",
            "/images/clientes/debora-miranda/posts/post-2.jpg",
            "/images/clientes/debora-miranda/posts/post-3.jpg",
            "/images/clientes/debora-miranda/posts/post-4.jpg",
            "/images/clientes/debora-miranda/posts/post-5.jpg",
            "/images/clientes/debora-miranda/posts/post-6.jpg",
            "/images/clientes/debora-miranda/posts/post-7.jpg",
            "/images/clientes/debora-miranda/posts/post-8.jpg",
        ],
    },
    {
        slug: "hm-chuveiros",
        name: "HM Chuveiros",
        menuLabel: "HM CHUVEIROS",
        service: "Brand Care",
        logo: "/images/clientes/hm-chuveiros/logo.png",
        cover: "/images/clientes/hm-chuveiros/cover-1.jpg",
        photos: [
            "/images/clientes/hm-chuveiros/cover-1.jpg",
            "/images/clientes/hm-chuveiros/cover-2.jpg",
            "/images/clientes/hm-chuveiros/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/hm-chuveiros/posts/fundo-principal.jpg",
        summary: [
            "A HM Chuveiros atua no segmento de equipamentos para chuveiros e soluções voltadas à segurança em ambientes que necessitam de sistemas de emergência.",
            "A empresa trabalha com produtos que exigem uma comunicação clara e, muitas vezes, técnica, já que suas aplicações estão diretamente relacionadas à instalação, utilização e segurança dos equipamentos.",
            "Seu portfólio contempla diferentes soluções para atender às necessidades específicas de seus clientes e do mercado em que atua.",
        ],
        posts: [
            "/images/clientes/hm-chuveiros/posts/post-1.jpg",
            "/images/clientes/hm-chuveiros/posts/post-2.jpg",
            "/images/clientes/hm-chuveiros/posts/post-3.jpg",
            "/images/clientes/hm-chuveiros/posts/post-4.jpg",
            "/images/clientes/hm-chuveiros/posts/post-5.jpg",
            "/images/clientes/hm-chuveiros/posts/post-6.jpg",
            "/images/clientes/hm-chuveiros/posts/post-7.jpg",
            "/images/clientes/hm-chuveiros/posts/post-8.jpg",
            "/images/clientes/hm-chuveiros/posts/post-9.jpg",
            "/images/clientes/hm-chuveiros/posts/post-10.jpg",
            "/images/clientes/hm-chuveiros/posts/post-11.jpg",
        ],
        deliverables: [
            "Redes Sociais",
            "Rebranding",
            "E-mail Marketing",
            "Páginas Comerciais",
            "Vídeos Youtube",
        ],
        figmaNode: "30:315",
    },
    {
        slug: "weheal-ftw",
        name: "WEHEAL / FTW",
        menuLabel: "WEHEAL / FTW",
        service: "Brand Care",
        bestCase: true,
        logo: "/images/clientes/weheal-ftw/logo.png",
        cover: "/images/clientes/weheal-ftw/cover-1.jpg",
        photos: [
            "/images/clientes/weheal-ftw/cover-1.jpg",
            "/images/clientes/weheal-ftw/cover-2.jpg",
            "/images/clientes/weheal-ftw/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/weheal-ftw/posts/fundo-principal.jpg",
        summary: [
            "A WEHEAL atua como uma representação comercial de produtos naturais, fazendo a conexão entre marcas do segmento de saúde, nutrição e esporte e redes de varejo.",
            "Atualmente, a empresa trabalha com produtos da FTW, marca de nutrição esportiva que possui em seu portfólio itens como whey protein, creatina e outros produtos voltados à prática esportiva e à saúde.",
            "Com atuação em Minas Gerais, funciona como uma ponte comercial entre fabricantes e diferentes mercados, levando essas marcas para redes e estabelecimentos do varejo.",
        ],
        posts: [
            "/images/clientes/weheal-ftw/posts/post-1.jpg",
            "/images/clientes/weheal-ftw/posts/post-2.jpg",
            "/images/clientes/weheal-ftw/posts/post-3.jpg",
            "/images/clientes/weheal-ftw/posts/post-4.jpg",
            "/images/clientes/weheal-ftw/posts/post-5.jpg",
            "/images/clientes/weheal-ftw/posts/post-6.jpg",
            "/images/clientes/weheal-ftw/posts/post-7.jpg",
            "/images/clientes/weheal-ftw/posts/post-8.jpg",
        ],
        testimonial: {
            person: "Marcos Barbosa",
            quote: [
                "Sou formado em Marketing, mas minha trajetória acabou sendo construída principalmente em Trade Marketing e estratégia de varejo. Quando surgiu a oportunidade de trabalhar com o André, buscava um profissional mais preparado, com experiência prática e capacidade de entender rapidamente um novo contexto.",
                "Em uma conversa despretensiosa, ele compartilhou um pouco da sua trajetória e, naquele momento, enxerguei potencial para construirmos uma parceria. Desde então, mostrou-se um profissional orientado, hands-on e capacitado, com grande capacidade de aprendizado e compreensão de um segmento completamente diferente da sua rotina.",
            ],
        },
    },
    {
        slug: "personalizei",
        name: "Personalizei",
        menuLabel: "PERSONALIZEI",
        logo: "/images/clientes/personalizei/logo.png",
        cover: "/images/clientes/personalizei/cover-1.jpg",
        photos: [
            "/images/clientes/personalizei/cover-1.jpg",
            "/images/clientes/personalizei/cover-2.jpg",
            "/images/clientes/personalizei/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/personalizei/posts/fundo-principal.jpg",
        summary: [
            "Na Personalizei, em conjunto com o Grupo Arantho, desenvolvemos a comunicação e do posicionamento da marca, pensando em como apresentar um novo app fitness de uma forma mais clara, profissional e atrativa para o público.",
            "Desenvolvemos estratégias de comunicação, envolvendo redes sociais, criando os temas, formatos e direcionamentos das publicações, além das peças gráficas e materiais de divulgação.",
            "Também trabalhamos para fortalecer a presença digital da Personalizei e mostrar, de forma mais simples, como a plataforma pode fazer parte da rotina dos profissionais de educação física.",
        ],
        posts: [
            "/images/clientes/personalizei/posts/post-1.jpg",
            "/images/clientes/personalizei/posts/post-2.jpg",
            "/images/clientes/personalizei/posts/post-3.jpg",
            "/images/clientes/personalizei/posts/post-4.jpg",
            "/images/clientes/personalizei/posts/post-5.jpg",
            "/images/clientes/personalizei/posts/post-6.jpg",
            "/images/clientes/personalizei/posts/post-7.jpg",
        ],
    },
    {
        slug: "samir-el-hage",
        name: "Samir El Hage",
        menuLabel: "SAMIR EL HAGE",
        service: "Identidade Visual",
        bestCase: true,
        logo: "/images/clientes/samir-el-hage/logo.png",
        cover: "/images/clientes/samir-el-hage/cover-1.jpg",
        photos: [
            "/images/clientes/samir-el-hage/cover-1.jpg",
            "/images/clientes/samir-el-hage/cover-2.jpg",
            "/images/clientes/samir-el-hage/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/samir-el-hage/posts/fundo-principal.jpg",
        summary: [
            "Samir é graduando de Psicologia e atua em São José do Rio Preto, construindo sua trajetória profissional na área.",
            "Em um momento de profissionalização, busca fortalecer sua presença nas redes sociais por meio de conteúdos relacionados à Psicologia e ao seu campo de atuação.",
            "A construção de uma comunicação mais consistente acompanha esse movimento de crescimento profissional e a intenção de ampliar sua carteira de clientes.",
        ],
        posts: [
            "/images/clientes/samir-el-hage/posts/post-1.jpg",
            "/images/clientes/samir-el-hage/posts/post-2.jpg",
            "/images/clientes/samir-el-hage/posts/post-3.jpg",
            "/images/clientes/samir-el-hage/posts/post-4.jpg",
            "/images/clientes/samir-el-hage/posts/post-5.jpg",
            "/images/clientes/samir-el-hage/posts/post-6.jpg",
            "/images/clientes/samir-el-hage/posts/post-7.jpg",
            "/images/clientes/samir-el-hage/posts/post-8.jpg",
            "/images/clientes/samir-el-hage/posts/post-9.jpg",
        ],
        testimonial: {
            person: "Samir El Hage",
            role: "Psicólogo",
            quote: [
                "Procurei a Rockfox com o objetivo de tornar a comunicação do meu trabalho mais estratégica, atrativa e alinhada ao meu posicionamento profissional. No entanto, encontrei uma parceria que foi muito além dessa expectativa.",
                "Ao longo do trabalho, foram desenvolvidos recursos, estratégias e elementos visuais que conseguiram traduzir não apenas aquilo que eu precisava comunicar nas redes sociais, mas também características do meu próprio perfil e da forma como quero me apresentar profissionalmente.",
                "Um dos grandes diferenciais, para mim, está no cuidado, na atenção e na transparência presentes em cada detalhe do processo. Além da qualidade das entregas, existe uma troca constante, com sugestões, novas ideias e propostas de inovação que realmente agregam ao trabalho.",
                "Mais do que a prestação de um serviço, encontrei uma parceria que torna todo o processo de construção da minha comunicação mais leve, produtivo e, principalmente, coerente com aquilo que quero transmitir.",
            ],
        },
    },
    {
        slug: "rrvenerando",
        name: "RRVENERANDO",
        menuLabel: "RRVENERANDO",
        service: "Identidade Visual",
        logo: "/images/clientes/rrvenerando/logo.png",
        cover: "/images/clientes/rrvenerando/cover-1.jpg",
        photos: [
            "/images/clientes/rrvenerando/cover-1.jpg",
            "/images/clientes/rrvenerando/cover-2.jpg",
            "/images/clientes/rrvenerando/cover-3.jpg",
        ],
        featuredImage: "/images/clientes/rrvenerando/posts/fundo-principal.jpg",
        summary: [
            "A RRVenerando atua no segmento de transporte e logística, realizando a intermediação entre empresas que precisam transportar suas cargas e transportadoras responsáveis pela operação.",
            "A empresa funciona como uma ponte entre o transportado e a transportadora, conectando demandas de transporte às soluções disponíveis no mercado. Sua atuação abrange todo o território brasileiro, atendendo operações de norte a sul do país.",
            "Dessa forma, a RR Venerando trabalha na articulação dessas relações dentro da cadeia de transporte, facilitando a conexão entre quem precisa movimentar cargas e quem realiza esse serviço.",
        ],
        posts: [
            "/images/clientes/rrvenerando/posts/post-1.png",
            "/images/clientes/rrvenerando/posts/post-2.png",
            "/images/clientes/rrvenerando/posts/post-3.png",
            "/images/clientes/rrvenerando/posts/post-4.png",
            "/images/clientes/rrvenerando/posts/post-5.png",
            "/images/clientes/rrvenerando/posts/post-6.png",
            "/images/clientes/rrvenerando/posts/post-7.png",
            "/images/clientes/rrvenerando/posts/post-8.png",
            "/images/clientes/rrvenerando/posts/post-9.png",
            "/images/clientes/rrvenerando/posts/post-10.png",
            "/images/clientes/rrvenerando/posts/post-11.png",
            "/images/clientes/rrvenerando/posts/post-12.png",
            "/images/clientes/rrvenerando/posts/post-13.png",
        ],
    },
];

export const CONTACT = {
    email: "adm@rockfoxstudio.com",
    instagram: { label: "@rockfoxstudio", href: "https://instagram.com/rockfoxstudio" },
    linkedin: { label: "LinkedIn", href: "https://www.linkedin.com/company/rock-fox-studio" },
    behance: { label: "Behance", href: "https://www.behance.net/andrandreetta1" },
    location: "São Paulo, Brasil",
};

// The four columns of the expanded menu (30:262), in the designed order.
export const NAV_COLUMNS = [
    {
        title: "CLIENTES",
        links: CLIENTS.filter((c) => !c.hiddenFromMenu).map((c) => ({
            label: c.menuLabel,
            to: `/cases/${c.slug}`,
        })),
    },
    {
        title: "SERVIÇOS",
        links: SERVICES.map((s) => ({ label: s.menuLabel, to: `/servicos/${s.slug}` })),
    },
    {
        title: "SOBRE",
        links: [
            { label: "ROCK FOX", to: "/sobre" },
            { label: "ANDRÉ", to: "/sobre/andre" },
            { label: "O QUE NOSSOS\nCLIENTES DIZEM", to: "/#depoimentos" },
        ],
    },
    {
        title: "CONTATO",
        links: [
            { label: "VAMOS CONVERSAR!", to: "/contato" },
        ],
    },
];

// Repeated calls to action, transcribed from the design.
export const CTA = {
    menu: {
        headline: "Comece a se destacar!",
        // Split so the second half can be bolded, as in 30:309.
        subhead: ["Vamos juntos criar a ", "qualidade que você merece."],
        action: "SOLICITE UM ORÇAMENTO!",
    },
    // Measured from 20:193, which draws the footer in full: 40px headline, 20px
    // supporting line, white button with orange label.
    footer: {
        headline: "Design que transforma marcas em referências",
        subhead: ["Ideias memoráveis para seu negócio ", "se destacar no mercado"],
        action: "SOLICITE UM ORÇAMENTO!",
    },
    service: {
        action: "INICIAR PROJETO",
    },
};

// The contact page has no Figma frame yet. Copy and fields below follow the
// studio's own voice and the conversational form Arthur asked for; when André
// designs it, this is what gets re-skinned.
export const CONTACT_PAGE = {
    headline: "Vamos criar algo memorável",
    subhead:
        "É simples falar com a gente. Preencha as lacunas abaixo e já começamos a entender o seu projeto.",
    // Each field completes a sentence, so `before` is both the visible copy and
    // the field's label.
    fields: [
        { name: "nome", before: "Olá Rock Fox, meu nome é", placeholder: "seu nome", type: "text", required: true },
        {
            name: "intencao",
            before: "e eu",
            type: "select",
            placeholder: "selecione",
            options: [
                "tenho um projeto em mente",
                "quero um orçamento",
                "quero conhecer o estúdio",
                "tenho outra dúvida",
            ],
        },
        { name: "empresa", before: "Represento a", placeholder: "sua empresa", type: "text" },
        { name: "email", before: "Você pode me responder em", placeholder: "seu e-mail", type: "email", required: true },
        { name: "whatsapp", before: "ou no WhatsApp", placeholder: "(00) 00000-0000", type: "tel" },
        { name: "site", before: "Meu site ou redes são", placeholder: "@ ou link", type: "text" },
        {
            name: "servico",
            before: "O serviço que procuro é",
            type: "select",
            placeholder: "selecione um serviço",
            options: ["Brand Care", "Identidade Visual", "Pack Post", "Design", "Ainda não sei"],
        },
        {
            name: "origem",
            before: "Encontrei vocês por",
            type: "select",
            placeholder: "selecione",
            options: ["Instagram", "Google", "Indicação", "Behance", "LinkedIn", "Outro"],
        },
    ],
    messagePlaceholder: "Conte um pouco sobre o seu projeto",
    action: "ENVIAR",
};

// Frame 20:193 — client cards. Each carries the service it was hired for, the
// company, what it does, and the person who signs it. The lower half of every
// card is a #D9D9D9 placeholder in the design, i.e. a portrait that does not
// exist yet.
//
// THE TESTIMONIALS ARE NOT HERE. They live on each client's case page, in
// `CLIENTS[].testimonial` above — Arthur's call (18/08/2026): a client's words
// belong on that client's page, not behind a control on the home.
//
// THE ORDER IS STILL DELIBERATE: the three clients who sent a testimonial come
// first, so the cards that lead somewhere with real content are the ones a
// visitor sees before scrolling.
//
// `photo` fills the lower half of the card — the #D9D9D9 block is the placeholder
// the Figma draws for exactly this. It is a piece of THE WORK, not a portrait of
// the person: Arthur's call (18/08/2026), and the only images that exist for these
// clients anyway. One per client, reusing the same 528x660 JPEGs the portfolio
// folders already ship, so the six cards add no new bytes to the repo.
//
// `-1.jpg` of each client, and there is nothing special about the 1: the handoff
// records that the order within a client is delivery order, not a ranking. Any of
// the three would do — Rio Grande in fact uses -2, for the reason noted there.
//
// WHEN ADDING ONE, CHECK THE CORNERS FIRST. Some pieces in this folder are rounded
// rectangles on white, with the corner baked into the JPEG, and a block that runs
// the image full-bleed turns that into white notches. Sample the four corners: if
// two or more come back near 255, pick a different piece.
//
// MIND THE CROP. The art is 4:5 and the slot is 258x260 — nearly square — so
// object-cover keeps the width and loses about 19% of the height. `photoFocus`
// (an object-position) chooses which 19%; the default keeps the top, where a
// social post usually carries its headline.
//
// `person` is duplicated with `CLIENTS[].testimonial.person` for those three.
// Same fact, two consumers — the card shows the name for all six clients,
// including the three with no testimonial, so neither side can be derived from
// the other. Change one, change the other.
export const TESTIMONIALS = {
    headline: "O que nossos clientes dizem",
    cards: [
        {
            id: "mylena-pereira",
            company: "HM Chuveiros",
            person: "Mylena",
            role: "Sócia HM Chuveiros",
            color: "#EAA011",
            rotation: -4,
            rating: 5,
            quote: [
                [
                    { text: "Profissional e estratégico.", bold: true },
                ],
                [
                    { text: "A experiência com a Rockfox tem sido positiva até aqui. Estamos trabalhando juntos há cerca de dois meses e, nesse período, tenho gostado da condução do projeto, da disponibilidade e da busca por entender as necessidades da nossa marca. Ainda estamos no início do trabalho, mas acredito que a parceria tem bastante potencial." },
                ],
                [
                    { text: "Tem sido uma experiência positiva trabalhar com a Rockfox. Mesmo sendo uma parceria relativamente recente, percebo cuidado em entender o nosso negócio e buscar soluções alinhadas ao que precisamos. Estamos construindo esse trabalho aos poucos e acredito que ainda teremos bastante coisa boa para desenvolver juntos." },
                ],
            ],
            href: "/cases/hm-chuveiros",
        },
        {
            id: "marcos-barbosa",
            company: "WEHEAL / FTW",
            person: "Marcos Barbosa",
            role: "Fundador WEHEAL",
            color: "#EA6D11",
            rotation: 8,
            rating: 5,
            quote: [
                [
                    { text: "Conduziu o projeto desde o briefing até a entrega com excelência." },
                ],
                [
                    { text: "Demonstrou excelente capacidade de " },
                    { text: "entender minhas expectativas", bold: true },
                    { text: " e direcioná-las para um cenário mais realista e aplicável. Manteve uma postura colaborativa e aberta a sugestões. Profissional comprometido, que " },
                    { text: "gera confiança e entrega valor", bold: true },
                    { text: "." },
                ],
            ],
            href: "/cases/weheal-ftw",
        },
        {
            id: "debora-miranda",
            company: "Débora Miranda",
            person: "Débora Miranda",
            role: "Fisioterapeuta + Pilates Solo",
            color: "#E05500",
            rotation: -3,
            rating: 5,
            quote: [
                [
                    { text: "Muito " },
                    { text: "profissional, atencioso, criativo e consegue entender exatamente o que eu quero", bold: true },
                    { text: " transmitir com o meu trabalho." },
                ],
                [
                    { text: "O projeto tem me ajudado muito a fortalecer minha imagem profissional e a mostrar meu trabalho de " },
                    { text: "uma forma mais bonita e estratégica", bold: true },
                    { text: "." },
                ],
            ],
            href: "/cases/debora-miranda",
        },
        {
            id: "renato-andreetta",
            company: "Andreetta Contabilidade",
            person: "Renato Andreetta",
            role: "Sócio Andreetta Contabilidade",
            color: "#C64A00",
            rotation: 5,
            rating: 5,
            quote: [
                [
                    { text: "Nosso escritório ganhou " },
                    { text: "muito mais visibilidade", bold: true },
                    { text: " desde o início da parceria com o André, e continuamos crescendo juntos." },
                ],
                [
                    { text: "É uma parceria sólida, construída com " },
                    { text: "confiança, dedicação e excelentes resultados", bold: true },
                    { text: ". Só temos a agradecer por todo o empenho e comprometimento." },
                ],
            ],
            href: "/cases/andreetta-contabilidade",
        },
        {
            id: "rogerio-venerando",
            company: "RRVENERANDO",
            person: "Rogério Venerando",
            role: "Fundador RRVENERANDO",
            color: "#9E3C00",
            rotation: -6,
            rating: 4,
            quote: [
                [
                    { text: "Excelente parceria na criação de materiais e comunicação para transportes nacionais. " },
                    { text: "Agilidade, dedicação e padrão visual impecável", bold: true },
                    { text: " em cada uma das entregas." },
                ],
            ],
            href: "/cases/rrvenerando",
        },
        {
            id: "samir-el-hage",
            company: "Samir El Hage",
            person: "Samir El Hage",
            role: "Graduando de Psicologia",
            color: "#EA7A00",
            rotation: -4,
            rating: 5,
            quote: [
                [
                    { text: "Trabalhar com a Rockfox é sentir que tem alguém preocupado em " },
                    { text: "estudar o seu negócio", bold: true },
                    { text: " e que fará o possível para trazer sua personalidade para seu trabalho." },
                ],
                [
                    { text: "Um dos diferenciais é o apoio constante e o cuidado com cada detalhe.", bold: true },
                ],
                [
                    { text: "Encontrei uma parceria que foi muito além da minha expectativa." },
                ],
            ],
            href: "/cases/samir-el-hage",
        },
    ],
};
// Frame 17:164 — the four services as a route into working with the studio.
export const WORK_TOGETHER = {
    headline: "Como podemos trabalhar juntos",
    subhead: "Toda grande marca começa com uma ideia bem construída.",
};

// Frame 17:100 — studio pitch over orange, then the portfolio grid.
//
// The design draws a 4x3 grid of 320px cards. Only one carries a real piece (a
// HM Chuveiros social post); the other eleven are #D9D9D9 placeholders, i.e.
// slots André has not filled yet. PIECES holds what actually exists and
// GRID_SLOTS is the designed count, so the layout keeps its shape while the
// empty slots stay visibly empty rather than being faked.
export const PORTFOLIO = {
    headline: "Um estúdio criativo especializado em Branding e Design.",
    body: [
        { text: "Cada projeto é desenvolvido para " },
        {
            text: "fortalecer a percepção da marca, criar conexões reais e acompanhar o crescimento do negócio.",
            bold: true,
        },
    ],
    action: "SOLICITE UM ORÇAMENTO!",
    // Uma pasta por cliente. O grid mostra exatamente quantas houver aqui e não
    // completa a linha com cinza: doze retângulos vazios dizem "estúdio sem
    // trabalho", três pastas cheias dizem "estúdio que começou".
    //
    // `photos` são as artes que aparecem no leque, sempre TRÊS. Com a lista
    // vazia, a pasta desenha três slots cinza e continua inteira.
    //
    // A ORDEM DOS CLIENTES é a da pasta CLIENTES que o André mantém no Drive,
    // onde cada cliente vem prefixado com um número (01_DEBORA, 02_HM, ...).
    // Esse prefixo é a ordem dele, então é a ordem daqui. O 07_PERSONALIZEI
    // existe lá mas chegou vazio — sem posts e sem logo —, e uma pasta sem nada
    // dentro não é uma pasta cinza bonita, é um cliente anunciado sem trabalho
    // para mostrar. Fica fora até as artes existirem; o slug já está em CLIENTS.
    // Não há 08 na pasta de origem: o 09 do RRVENERANDO não é um erro de
    // digitação daqui.
    //
    // AS ARTES CHEGAM CRUAS, e isto é uma mudança em relação ao primeiro lote:
    // são posts 1080x1350 (4:5) full-bleed, sem moldura, sem sombra, sem rotação
    // e sem margem transparente. Quem desenha a moldura branca agora é o
    // ClientFolder, para foto real e para slot vazio pelo mesmo caminho.
    //
    // Por isso a ordem DENTRO de cada cliente é livre — é a de entrega. Antes
    // não era: cada mockup vinha pré-inclinado e tinha de cair no slot cuja
    // inclinação combinava, e a lista saía "3, 2, 1". Se um dia voltarem artes
    // montadas, é o FAN no ClientFolder que volta a ser medido arquivo por
    // arquivo.
    //
    // Os assets em public/images/clientes/ são derivados: post -> JPEG 528x660
    // (as fotos aparecem a ~170x210 CSS px, então 660 cobre até 3x), logo -> PNG
    // com alfa, largura máxima 700. Os originais ficam no Drive; o zip do dia
    // 12/08/2026 tinha 23 MB e o que está versionado aqui são 2,0 MB.
    //
    // Cada `href` aponta para um case que já existe em CLIENTS acima; nenhuma
    // rota nova foi criada para isto.
    folders: [
        {
            id: "debora-miranda",
            client: "Débora Miranda",
            tags: "ID, Social Media",
            logo: "/images/clientes/debora-miranda/logo.png",
            href: "/cases/debora-miranda",
            photos: [
                { src: "/images/clientes/debora-miranda/cover-1.jpg" },
                { src: "/images/clientes/debora-miranda/cover-2.jpg" },
                { src: "/images/clientes/debora-miranda/cover-3.jpg" },
            ],
        },
        {
            id: "hm-chuveiros",
            client: "HM Chuveiros",
            tags: "Brand Care",
            logo: "/images/clientes/hm-chuveiros/logo.png",
            logoClassName: "max-h-[48px] sm:max-h-[52px] max-w-[175px]",
            noInvert: true,
            href: "/cases/hm-chuveiros",
            photos: [
                { src: "/images/clientes/hm-chuveiros/cover-1.jpg" },
                { src: "/images/clientes/hm-chuveiros/cover-2.jpg" },
                { src: "/images/clientes/hm-chuveiros/cover-3.jpg" },
            ],
        },
        {
            id: "andreetta-contabilidade",
            client: "Andreetta Contabilidade",
            tags: "Brand Care",
            logo: "/images/clientes/andreetta-contabilidade/logo.png",
            href: "/cases/andreetta-contabilidade",
            photos: [
                { src: "/images/clientes/andreetta-contabilidade/cover-1.jpg" },
                { src: "/images/clientes/andreetta-contabilidade/cover-2.jpg" },
                { src: "/images/clientes/andreetta-contabilidade/cover-3.jpg" },
            ],
        },
        {
            id: "weheal-ftw",
            client: "WEHEAL",
            tags: "ID, Social Media, Strategy",
            logo: "/images/clientes/weheal-ftw/logo.png",
            href: "/cases/weheal-ftw",
            photos: [
                { src: "/images/clientes/weheal-ftw/cover-1.jpg" },
                { src: "/images/clientes/weheal-ftw/cover-2.jpg" },
                { src: "/images/clientes/weheal-ftw/cover-3.jpg" },
            ],
        },
        {
            id: "rio-grande-pescados",
            client: "Rio Grande Pescados",
            tags: "Social Media",
            logo: "/images/clientes/rio-grande-pescados/logo.png",
            logoClassName: "max-h-[48px] sm:max-h-[52px] max-w-[170px]",
            href: "/cases/rio-grande-pescados",
            photos: [
                { src: "/images/clientes/rio-grande-pescados/cover-1.jpg" },
                { src: "/images/clientes/rio-grande-pescados/cover-2.jpg" },
                { src: "/images/clientes/rio-grande-pescados/cover-3.jpg" },
            ],
        },
        {
            id: "samir-el-hage",
            client: "Samir El Hage",
            tags: "ID, Social Media",
            logo: "/images/clientes/samir-el-hage/logo.png",
            noInvert: true,
            href: "/cases/samir-el-hage",
            photos: [
                { src: "/images/clientes/samir-el-hage/cover-1.jpg" },
                { src: "/images/clientes/samir-el-hage/cover-2.jpg" },
                { src: "/images/clientes/samir-el-hage/cover-3.jpg" },
            ],
        },
        {
            id: "rrvenerando",
            client: "RRVENERANDO",
            tags: "ID, Social Media",
            logo: "/images/clientes/rrvenerando/logo.png",
            href: "/cases/rrvenerando",
            photos: [
                { src: "/images/clientes/rrvenerando/cover-1.jpg" },
                { src: "/images/clientes/rrvenerando/cover-2.jpg" },
                { src: "/images/clientes/rrvenerando/cover-3.jpg" },
            ],
        },
        {
            id: "personalizei",
            client: "Personalizei",
            tags: "Creative Director, Content Manager",
            logo: "/images/clientes/personalizei/logo.png",
            href: "/cases/personalizei",
            photos: [
                { src: "/images/clientes/personalizei/cover-1.jpg" },
                { src: "/images/clientes/personalizei/cover-2.jpg" },
                { src: "/images/clientes/personalizei/cover-3.jpg" },
            ],
        },
    ],
};

export const POSITIONING = {
    headline: "Criatividade que faz sua marca ser lembrada.",
    body: [
        [{ text: "Desenvolvemos sistemas visuais e estratégias capazes de transformar negócios em marcas fortes." }],
        [
            { text: "Criamos experiências de marca que conectam " },
            { text: "estratégia, criatividade e personalidade", bold: true },
            { text: " para empresas que querem crescer com consistência." },
        ],
    ],
    action: "VAMOS CONVERSAR!",
    // 4 chosen ultra high-res client posts for auto-cycling carousel
    slides: [
        { id: "slide-samir", image: "/images/clientes/samir-el-hage/posts/post-1.jpg" },
        { id: "slide-weheal", image: "/images/clientes/weheal-ftw/posts/post-4.jpg" },
        { id: "slide-personalizei", image: "/images/clientes/personalizei/posts/post-3.jpg" },
        { id: "slide-debora", image: "/images/clientes/debora-miranda/posts/post-1.jpg" },
    ],
};

export const STUDIO = {
    name: "ROCK FOX STUDIO",
    headline: "Criatividade que faz sua marca ser lembrada.",
    positioning: "Um estúdio criativo especializado em Branding e Design.",
    // Words orbiting the logotype in 16:114.
    keywords: ["DESIGN", "ESTRATÉGIA", "CRIATIVIDADE", "BRANDING", "INOVAÇÃO"],
};

export const FOUNDER = {
    name: "André Andreetta",
    role: "Brand Creative Designer",
    // How the home introduces him (20:180), distinct from the Behance byline above.
    homeTitle: "Fundador da Rock Fox Studio",
    quote: "“A tecnologia acelerou o processo criativo. Mas criatividade nunca foi sobre velocidade. É sobre visão, repertório e intenção. Acreditamos que grandes marcas nascem da combinação entre estratégia, design e autenticidade.”",
    bio: [
        "Sempre fui criativo e gostei de transformar ideias em coisas novas.",
        "A publicidade entrou na minha vida de forma natural e me conquistou pela possibilidade de trabalhar com diferentes marcas, negócios e desafios.",
        "Hoje, atuo como publicitário, com foco cada vez maior em Branding, Estratégia e Design, buscando entender profundamente cada cliente antes de começar a criar. Foi dessa visão que nasceu a Rock Fox: um estúdio pensado para desenvolver soluções criativas, bonitas e, principalmente, que façam sentido para o negócio.",
        "Meu objetivo é construir projetos que tenham personalidade, funcionem de verdade e sejam diferentes do que se encontra por aí.",
    ],
    homeParagraphs: [
        "Meu trabalho é entender o negócio, organizar as ideias e transformar tudo isso em uma comunicação que faça sentido.",
        "Que tenha personalidade, que seja bonita, mas principalmente que tenha propósito.",
        "Porque não adianta uma marca ter uma identidade incrível se ninguém entende o que ela faz, para quem ela existe ou por que deveria escolher aquela empresa.",
    ],
    photo: "/images/andre/andre-andreetta.jpg",
    instagram: "@andreandreetta",
    email: "adm@rockfoxstudio.com",
    education: [
        { school: "PUC Campinas", course: "Publicidade e Propaganda" },
        { school: "ESPM", course: "Master in Branding" },
    ],
    gallery: [
        { id: "1", image: "/images/andre/andre1.jpeg" },
        { id: "2", image: "/images/andre/andre2.jpeg" },
        { id: "3", image: "/images/andre/andre3.jpeg" },
        { id: "4", image: "/images/andre/andre4.jpeg" },
    ],
};

// Gallery of brand showcase cards for the bottom of service pages.
export const SERVICE_GALLERY = [
    { id: "1", src: "/images/brand/brand1.jpg", alt: "Brand Experience e Serviços RockFox" },
    { id: "2", src: "/images/brand/brand2.jpg", alt: "Seja bem vindo Rock Fox Studio" },
    { id: "3", src: "/images/brand/brand3.jpg", alt: "As melhores ideias são construídas pensando em pessoas" },
    { id: "4", src: "/images/brand/brand4.jpg", alt: "Go create now teclado RockFox" },
    { id: "5", src: "/images/brand/brand5.jpg", alt: "Work files designs e ideias" },
    { id: "6", src: "/images/brand/brand6.jpg", alt: "Temos novidades por aqui rockfoxstudio.com" },
];
